import React from "react";

import Images from "../../images";

const CopyrightPage = () => (
  <div>
    <div
      style={{
        fontFamily: "Helvetica, sans-serif",
        fontSize: 20,
        background: "#fff",
        textRendering: "optimizeLegibility"
      }}
    >
      <div style={{ paddingTop: 50 }}>
        <div style={{ width: 260, margin: "0 auto" }}>
          <a
            href="/"
            style={{ display: "block", textDecoration: "none", outline: 0 }}
          >
            <img
              src={Images.logo}
              alt="Cliffhanger"
              style={{ width: "100%", maxWidth: "100%" }}
            />
          </a>
        </div>
      </div>
    </div>

    <div className="content page">
      <div className="hero">
        <div className="lockup">
          <div className="heading">
            <h1 className="title">Copyright</h1>
          </div>
        </div>
      </div>
      <p>Effective Date: June 12, 2017</p>
      <p>
        Hype Bits, Inc. (“Hype Bits”) respects the intellectual property of
        others and asks that users of Hype Bits’ services do the same. In
        connection with the services, Hype Bits has implemented a policy (below)
        that provides for the removal of any infringing materials in appropriate
        circumstances.
      </p>
      <p>
        Notice Procedure. If you believe that your work has been copied in a way
        that constitutes infringement of a copyright or other intellectual
        property, please provide Hype Bits’ Copyright Agent (as identified
        below) the following information:
      </p>
      <ul>
        <li>
          An electronic or physical signature of the person authorized to act on
          behalf of the owner of the copyright or other intellectual property
          interest;
        </li>
        <li>
          A description of the copyrighted work or other intellectual property
          that you claim has been infringed;
        </li>
        <li>
          A description of where the material that you claim is infringing is
          located on the services;
        </li>
        <li>Your name, address, telephone number and email address;</li>
        <li>
          A statement by you that you have a good faith belief that the disputed
          use is not authorized by the copyright owner, its agent, or the law;
          and
        </li>
        <li>
          A statement by you, made under penalty of perjury, that the above
          information in your notice is accurate and that you are the copyright
          or intellectual property owner or authorized to act on the copyright
          or intellectual property owner’s behalf.
        </li>
      </ul>
      <p>
        Counter-Notice Procedure. If you believe that your submission of content
        to our services was removed (or access to which was disabled) as a
        result of a notice of infringement and that the content is not
        infringing, or that you have the authorization from the copyright owner,
        the copyright owner’s agent, or pursuant to the law, to post and use the
        content on the services, you may send to the Copyright Agent a
        counter-notice containing the following information:
      </p>
      <ul>
        <li>Your electronic or physical signature;</li>
        <li>
          Identification of the content that has been removed (or to which
          access was disabled) and the location at which the content appeared
          before it was removed or disabled;
        </li>
        <li>
          A statement that you have a good faith belief that the content was
          removed or disabled as a result of mistake or a misidentification of
          the content; and
        </li>
        <li>Your name, address, telephone number and e-mail address,</li>
        <li>
          A statement that you consent to the jurisdiction of the U.S. Federal
          courts located in San Francisco County, California; and
        </li>
        <li>
          A statement that you will accept service of process from the person
          who provided notification of the alleged infringement.
        </li>
      </ul>
      <p>
        If a counter-notice is received by the Copyright Agent, Hype Bits may
        send a copy of the counter-notice to the original complaining party
        informing that person that it may replace the removed content or cease
        disabling it in ten business days. Unless the copyright owner files an
        action seeking a court order against the content provider, member or
        user, the removed content may be replaced, or access to it restored, in
        ten to fourteen business days (or more) after receipt of the
        counter-notice. Replacement or restoration of access to the content
        shall be in Hype Bits’ sole discretion.
      </p>
      <p>
        Please note that any misrepresentation of any material fact in any
        notice above may automatically subject you to liability for any related
        damages, costs and attorney fees incurred by Hype Bits pursuant to 17
        U.S.C. Section 512(f).
      </p>
      <p>
        Hype Bits’ Copyright Agent, for notice of claims of infringement and
        counter-notices, can be reached as follows:
      </p>
      <p>By mail:</p>
      <p>Hype Bits, Inc.</p>
      <p>Attn: Copyright Agent</p>
      <p>3500 South DuPont Highway</p>
      <p>Dover, DE 19901</p>
      <p>By telephone: 415-371-1333</p>
      <p>By fax: 866-582-9178</p>
      <p>
        Support:{" "}
        <a href="https://cliffhangersupport.zendesk.com/hc/en-us/requests/new">
          https://cliffhangersupport.zendesk.com/hc/en-us/requests/new
        </a>
      </p>
    </div>

    <div className="footer">
      <a href="/legal/copyright/">Copyright</a>
      <a href="/legal/privacy/">Privacy Policy</a>
      <a href="/legal/subscription/">Subscription</a>
      <a href="/legal/terms/">Terms of Service</a>
    </div>
  </div>
);

export default CopyrightPage;



// WEBPACK FOOTER //
// ./src/pages/legal/copyright.js